var _g, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 40,
    viewBox: "0 0 34 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4764_462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6111 9H10.3889C8.82465 9 7.54965 10.3199 7.60868 11.9184C7.62049 12.2393 7.63229 12.5602 7.65 12.875H1.41667C0.631597 12.875 0 13.5229 0 14.3281C0 19.9348 1.97743 23.834 4.63368 26.4799C7.24861 29.0895 10.4361 30.4033 12.7854 31.0693C14.1667 31.4629 15.1111 32.6436 15.1111 33.8303C15.1111 35.0957 14.1076 36.125 12.874 36.125H11.3333C10.2885 36.125 9.44444 36.9908 9.44444 38.0625C9.44444 39.1342 10.2885 40 11.3333 40H22.6667C23.7115 40 24.5556 39.1342 24.5556 38.0625C24.5556 36.9908 23.7115 36.125 22.6667 36.125H21.126C19.8924 36.125 18.8889 35.0957 18.8889 33.8303C18.8889 32.6436 19.8274 31.4568 21.2146 31.0693C23.5698 30.4033 26.7573 29.0895 29.3722 26.4799C32.0226 23.834 34 19.9348 34 14.3281C34 13.5229 33.3684 12.875 32.5833 12.875H26.35C26.3677 12.5602 26.3795 12.2453 26.3913 11.9184C26.4503 10.3199 25.1753 9 23.6111 9ZM2.88646 15.7812H7.8684C8.40556 21.2365 9.59201 24.8814 10.9319 27.3215C9.46215 26.6555 7.93333 25.717 6.61111 24.3971C4.72222 22.5141 3.1875 19.7955 2.89236 15.7812H2.88646ZM27.3948 24.3971C26.0726 25.717 24.5437 26.6555 23.074 27.3215C24.4139 24.8814 25.6003 21.2365 26.1375 15.7812H31.1194C30.8184 19.7955 29.2837 22.5141 27.4007 24.3971H27.3948Z",
    fill: "url(#paint0_linear_4764_462)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 20.5,
    r: 3.25,
    fill: "url(#paint1_linear_4764_462)",
    stroke: "white",
    strokeWidth: 1.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.61875 1.42413C8.96037 1.18989 9.38412 1.30199 9.56522 1.67452L11.4094 5.468C11.5905 5.84053 11.4604 6.33241 11.1187 6.56665C10.7771 6.80089 10.3534 6.68878 10.1723 6.31626L8.3281 2.52277C8.147 2.15025 8.27712 1.65837 8.61875 1.42413Z",
    fill: "url(#paint2_linear_4764_462)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.75 -3.89342e-08C18.1642 -1.74314e-08 18.5 0.335786 18.5 0.75L18.5 5.25C18.5 5.66421 18.1642 6 17.75 6C17.3358 6 17 5.66421 17 5.25L17 0.75C17 0.335786 17.3358 -6.0437e-08 17.75 -3.89342e-08Z",
    fill: "url(#paint3_linear_4764_462)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1187 1.57587C26.4604 1.81011 26.5905 2.30199 26.4094 2.67452L24.5652 6.468C24.3841 6.84053 23.9604 6.95263 23.6187 6.71839C23.2771 6.48415 23.147 5.99227 23.3281 5.61975L25.1723 1.82626C25.3534 1.45374 25.7771 1.34163 26.1187 1.57587Z",
    fill: "url(#paint4_linear_4764_462)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4764_462",
    x1: 17,
    y1: 9,
    x2: 17,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF997B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4764_462",
    x1: 17.5,
    y1: 18,
    x2: 17.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF997B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4764_462",
    x1: 10.4873,
    y1: 3.57126,
    x2: 9.15313,
    y2: 4.21986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF997B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4764_462",
    x1: 18.5,
    y1: 3,
    x2: 17,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF997B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4764_462",
    x1: 25.4873,
    y1: 4.57126,
    x2: 24.1531,
    y2: 3.92266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF997B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4764_462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 31,
    fill: "white",
    transform: "translate(0 9)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.9b9775d0c25107bff1689f15a075fbd2.svg";
export { ForwardRef as ReactComponent };